<template>
  <div id="DevicePage">
    <section class="section">
      <div class="container">
        <h1 class="title is-primary" style="color: #00AEEF; font-weight: 100;">
          {{ $t("devices.title") }}
        </h1>
        <!-- Search Customer Section -->
        <div class="columns">
          <!-- Input Field -->
          <div class="column is-4-desktop is-12-mobile">
            <b-field>
              <b-input
                type="search"
                icon="magnify"
                custom-class="dtac-font"
                v-model="inputText"
                :placeholder="$t('devices.search.placeholder')"
                @keyup.native.enter="submitFilterString"
              />
            </b-field>
          </div>
          <!-- Button Search -->
          <div class="column is-1-desktop is-12-mobile">
            <b-button
              type="is-primary"
              class="full-width dtac-font"
              @click.prevent="submitFilterString"
              >{{ $t("devices.search.button") }}</b-button
            >
          </div>
          <!-- Batch Upload Device Button -->
          <div class="column is-2-desktop is-12-mobile is-offset-5">
            <b-button
              outlined
              type="is-primary"
              icon-left="playlist-plus"
              class="full-width dtac-font"
              @click="popupFormCreateNewDevice"
              >{{ $t("devices.btn_create_device") }}</b-button
            >
          </div>
        </div>
        <device-table :filter="filterString" />
      </div>
    </section>
  </div>
</template>

<script>
import DeviceTable from "@/components/tables/DeviceTable.vue";
import NewDeviceUploadForm from "@/components/forms/NewDeviceUploadForm.vue";

export default {
  name: "DevicePage",
  components: {
    DeviceTable
  },
  data() {
    return {
      inputText: null,
      filterString: null
    };
  },
  methods: {
    submitFilterString: function() {
      if (this.inputText && this.inputText !== "") {
        this.filterString = this.inputText;
      } else {
        this.filterString = null;
      }
    },
    popupFormCreateNewDevice: function() {
      this.$buefy.modal.open({
        parent: this,
        hasModalCard: true,
        component: NewDeviceUploadForm
      });
    }
  }
};
</script>

<style></style>
